// ────────────────────────────────────────────────────────────
// src/appredux/index.ts               ← full file (copy-paste)
// ────────────────────────────────────────────────────────────
import {createStore, compose, applyMiddleware} from 'redux';
import {thunk} from 'redux-thunk';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createCompressor from 'redux-persist-transform-compress';
import {encryptTransform} from 'redux-persist-transform-encrypt';

import rootReducer from './reducers';

/* ───────── persist config ───────── */
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'products',
    'subSubCategories',
    'depots',
    'quotes',
    'invoices',
    'purchaseOrders',
    'purchaseOrderStatuses',
    'programs',
    'applications',
    'dashboardWidgets',
    'rdwDateFilter',
  ],
  transforms: [
    createCompressor(),
    encryptTransform({
      secretKey: 'g]VHT*<spU2R.CGM2tTuK^.4Y.)Q8/L-',
      onError(error) {
        /* eslint-disable no-console */
        console.error('Error encrypting redux persist', error);
      },
    }),
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

/* ───────── DevTools enhancer ───────── */
const composeEnhancers =
  (process.env.REACT_APP_ENV === 'development' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

/* ───────── STORE / PERSISTOR ───────── */
export const STORE = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk)),
);

export const PERSISTOR = persistStore(STORE);

/* expose store in dev console for quick testing */
if (process.env.REACT_APP_ENV === 'development') {
  (window as any).STORE = STORE;
}
